import { axiosClient } from "@/configurations/axios"
import { queryClient } from "@/configurations/react-query"
import { TQueryOptions } from "@/types/api"
import { queryOptions, useQuery } from "@tanstack/react-query"
import { EVENT_DATE_ENDPOINTS, EVENT_DATE_KEYS } from "../configs/endpoints"
import { TEventDay } from "../types"

export const getEventDayUpComing = async () => {
  const response = await axiosClient.get<TEventDay>(
    EVENT_DATE_ENDPOINTS.getEventDateUpcoming
  )
  return response.data
}

export const useGetEventDayUpComing = <
  TSelect = Awaited<ReturnType<typeof getEventDayUpComing>>
>(
  options?: TQueryOptions<typeof getEventDayUpComing, TSelect>
) => {
  return useQuery({
    queryKey: EVENT_DATE_KEYS.getEventDateUpcoming(),
    queryFn: () => getEventDayUpComing(),
    ...options
  })
}
export const getEventDayUpComingQueryOptions = () => {
  return queryOptions({
    queryKey: EVENT_DATE_KEYS.getEventDateUpcoming(),
    queryFn: () => getEventDayUpComing()
  })
}
export const getEventDayUpComingLoader = () => {
  return queryClient.ensureQueryData(getEventDayUpComingQueryOptions())
}
